module.exports = __webpack_public_path__ + "img/thumbnail_ChinesePangolin_j_normal.30326f4b.png";